import get from 'lodash.get';

const getSentryDSN = (rootState) =>
  get(rootState, 'config.service.yola-template-gallery.sentry_dsn');

export default getSentryDSN;
